var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabelTag = function SvgLabelTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.616 12.317a1.2 1.2 0 0 1-1.698 0L2.35 9.75a1.2 1.2 0 0 1 0-1.698l4.332-4.33c.25-.25.59-.39.943-.39h2.377c.737 0 1.334.597 1.334 1.333V7.04c0 .353-.14.692-.39.942z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.003 5.333v2.532c0 .354-.141.693-.391.943l-3.777 3.777"
  })));
};
export { SvgLabelTag as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOWU0ZWQ4NjVhOWQ3MzgyZTc3NDE5NjQzNWY3NjEzOTAuc3ZnIjs=";